import Immutable from 'seamless-immutable';
import {
  FETCH_LIST_START,
  FETCH_LIST_SUCCESS,
  FETCH_LIST_ERROR
} from '../Actions/ChildrenList';

const initialState = Immutable({
  list: [],
  numberOfFulfilledWishes: 0,
  numberOfWishes: 0,
  fetching: false,
  success: false,
  error: null
});

export default function childrenListReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LIST_START:
      return Immutable.merge(state, {
        list: [],
        numberOfFulfilledWishes: 0,
        numberOfWishes: 0,
        fetching: true,
        success: false,
        error: null
      });
    case FETCH_LIST_SUCCESS:
      return Immutable.merge(state, {
        list: action.payload.list,
        numberOfFulfilledWishes: action.payload.numberOfFulfilledWishes,
        numberOfWishes: action.payload.numberOfWishes,
        fetching: false,
        success: true,
        error: null
      });
    case FETCH_LIST_ERROR:
      return Immutable.merge(state, {
        list: [],
        numberOfFulfilledWishes: 0,
        numberOfWishes: 0,
        fetching: false,
        success: false,
        error: action.payload.error
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/ChildrenListReducer.js